import i18n from '@/lang/i18n'

export default [{
  path: '/admin/apply/institution/list',
  name: 'institutionList',
  component: () => import('@/views/apply/institution/list/index'),
  meta: {
    title: i18n.t('router.institution.enterprise_manage'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/institution/config',
  name: 'institutionConfig',
  component: () => import('@/views/apply/institution/config'),
  meta: {
    title: i18n.t('router.institution.basic_config'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/institution/classify',
  name: 'institutionClassify',
  component: () => import('@/views/apply/institution/classify'),
  meta: {
    title: i18n.t('router.institution.enterprise_category'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/institution/power',
  name: 'institutionPower',
  component: () => import('@/views/apply/institution/power/index'),
  meta: {
    title: i18n.t('router.institution.permission_manage'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/institution/account',
  name: 'institutionAccount',
  component: () => import('@/views/apply/institution/account/index'),
  meta: {
    title: i18n.t('router.institution.account_manage'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/institution/scene/list',
  name: 'institutionScene',
  component: () => import('@/views/apply/institution/scene/index'),
  meta: {
    title: i18n.t('router.institution.scene_manage'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/institution/role/list',
  name: 'institutionRole',
  component: () => import('@/views/apply/institution/role/index'),
  meta: {
    title: i18n.t('router.institution.role_manage'),
    headType: 0,
    auth: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/apply/institution.js